export const FIELD_MAPPINGS = {
  period: 'periodName',
  countrytaxtype: 'countryTaxType',
  type: 'type',
  activity: 'activity',
  slaccount: 'slAccount',
  gaap: 'gaap',
  g2s: 'g2s',
  line: 'line',
  direction: 'direction',
  glaccountcurrent: 'glAccountCurrent',
  glaccountprior: 'glAccountPrior',
  glaccount2ndprior: 'glAccount2ndPrior',
};

export const MIN_COLUMNS_NUMBER = 12;

export const MAX_COLUMNS_NUMBER = 12;
